import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { forwardRef } from "react";
const SvgAttention = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 26, height: 26, viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M13 1.1365e-06C20.1792 5.08866e-07 26 5.82075 26 13C26 20.1793 20.1793 26 13 26C5.82075 26 1.76413e-06 20.1793 1.1365e-06 13C5.08866e-07 5.82075 5.82075 1.76413e-06 13 1.1365e-06ZM11.687 5.41667L11.9037 15.1667L14.0963 15.1667L14.313 5.41667L11.687 5.41667ZM12.9968 20.7881C13.8938 20.7881 14.43 20.3103 14.43 19.5076C14.43 18.6897 13.8948 18.2119 12.9968 18.2119C12.1063 18.2119 11.5711 18.6897 11.5711 19.5076C11.5711 20.3103 12.1063 20.7881 12.9968 20.7881Z", fill: "#9D4C6C" })
] });
const ForwardRef = forwardRef(SvgAttention);
export default ForwardRef;
